import React, { FunctionComponent } from 'react'
import NonFlexingContainer from '../../../Layouts/NonFlexingContainer'
import CaptionFont from '../../../Theme/Fonts/Caption'
import Divider from '../../../BaseComponents/Divider'

export type MatchHeaderProps = {
    /** inserts a divider at the bottom */
    hasDivider?: boolean
    /** text to be displayed */
    children: string
}

const MatchHeader: FunctionComponent<MatchHeaderProps> = ({ hasDivider, children }) => (
    <NonFlexingContainer width="100%" backgroundColor="pearl" height={33}>
        <NonFlexingContainer spaceLeft="standard" spaceY="small" height={32}>
            <CaptionFont color="keshi-3">{children}</CaptionFont>
        </NonFlexingContainer>
        {hasDivider ? <Divider dark /> : null}
    </NonFlexingContainer>
)

export default MatchHeader
